// shared-lib/cabinet-runs/vendors/venus/sinkFronts.js
//
// The FRONTS of Venus's vanity sink cabinets, as its 2024 catalog draws them
// (printed page 21, "Vanity Sink Drawer Base"): which columns stand side by
// side and how wide each is, in inches as the drawing dimensions them. The
// price sheet the size catalog is generated from (`catalog.json`) lists only
// part numbers and sizes, so a sink-drawer unit drawn from its kind alone came
// out as one wide sink front — the 60" double, with a bank of drawers between
// its two basins, looked like a 60" pair of doors (user report, 2026-10-30).
//
// A part with no entry is a plain sink base: a false drawer front over doors
// (every VSB, "2 Door & 1 False Drawer"), which is the `sink-front` column the
// run already gives a sink bay. Hand-kept, like the corner sets in
// `families/venus.json`: the catalog PDF is image-only.
//
// Each drawer bank is drawn as the catalog draws it — a short front over two
// equal ones (6¾" over 11⅛" + 11⅛") — whatever the line's description calls
// the short one: the 60" single's is a drawer ("6 Drawer"), the 36"'s goes
// uncounted ("2 Left Drawer"). The widths add up to an inch or two under the
// box (the face frame's stiles); `sinkUnits.sinkUnitColumns` scales them to
// the box.
//
// Pure data.

/** A bank of drawers: the catalog's three fronts, the top one short. */
const drawers = (w) => ({
  type: 'drawers',
  w,
  drawerCount: 3,
  graduated: true,
});

/** The section under a basin: a false drawer front over `doors` doors. */
const sink = (w, doors = null) => ({
  type: 'sink-front',
  w,
  ...(doors ? { doors } : {}),
});

const SINK_FRONTS = Object.freeze({
  // 30": "1 Door & 2 Left / Right Drawer" — one door under the basin.
  VSD3021L: [drawers(11.75), sink(17.5, 1)],
  VSD3021R: [sink(17.5, 1), drawers(11.75)],
  // 36": "2 Door & 2 Left / Right Drawer".
  VSD3621L: [drawers(11.5), sink(23.5)],
  VSD3621R: [sink(23.5), drawers(11.5)],
  // 42": "2 Door, 2 Drawer & False Drawer" — ONE door section whose top row
  // is a drawer, the false front and a drawer (11½" | 17½" | 11½"), its two
  // doors running under all three.
  VSD4221: [{ ...sink(40.5), sideDrawers: 11.5 }],
  // 48": "2 Door, 4 Drawer & False Drawer".
  VSD4821: [drawers(11.5), sink(23.5), drawers(11.5)],
  // 60" single: "2 Door, 6 Drawer & False Drawer".
  VSD60SINGLE: [drawers(14.5), sink(29.5), drawers(14.5)],
  // 60" double: "4 Door, 3 Drawer & 2 False Drawer" — a sink each end, the
  // drawers between the basins.
  VSD60DOUBLE: [sink(23.5), drawers(11.5), sink(23.5)],
});

module.exports = { SINK_FRONTS };
